import { motion } from 'framer-motion';

export default function How() {
    const steps = [
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-yellow-400" viewBox="0 0 24 24">
                    <path fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 10V3L4 14h7v7l9-11h-7z"/>
                </svg>
            ),
            number: "01",
            title: "Realizar su pedido",
            description: "Elija la suscripción que le convenga y proceda al pago seguro en unos pocos clics.",
            bgColor: "bg-yellow-400",
            numberColor: "text-white"
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-yellow-400" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"/>
                </svg>
            ),
            number: "02",
            title: "Recepción de accesos",
            description: "Reciba instantáneamente sus credenciales de conexión por correo electrónico con una guía de instalación detallada.",
            bgColor: "bg-yellow-400",
            numberColor: "text-white"
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-yellow-400" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M8 5v14l11-7z"/>
                </svg>
            ),
            number: "03",
            title: "Disfrute del contenido",
            description: "Conéctese y acceda inmediatamente a más de 79,000 canales y VOD en 4K/UHD.",
            bgColor: "bg-yellow-400",
            numberColor: "text-white"
        }
    ]

    return (
        <main className="relative overflow-hidden py-20">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255, 184, 0, 0.1) 0%, transparent 50%),
                                    radial-gradient(circle at 75% 75%, rgba(255, 184, 0, 0.1) 0%, transparent 50%)`,
                }}></div>
            </div>

            <div className="container mx-auto px-4 sm:px-6 relative z-10">
                {/* Header Section */}
                <div className="text-center mb-24">
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="inline-flex items-center justify-center mb-6"
                    >
                        <span className="text-yellow-400 text-xs md:text-sm font-bold uppercase tracking-wider px-6 py-2 rounded-full border border-yellow-400/30 bg-yellow-400/10 backdrop-blur-sm">
                            INICIO RÁPIDO
                        </span>
                    </motion.div>

                    <motion.h1 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                        className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6"
                    >
                        <span className="text-white">Cómo</span>{" "}
                        <span className="text-yellow-400">funciona?</span>
                    </motion.h1>

                    <motion.p 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="text-gray-400 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed"
                    >
                        Una instalación simple y rápida en 3 pasos para comenzar a ver sus programas favoritos hoy mismo.
                    </motion.p>
                </div>

                {/* Steps Section */}
                <div className="mb-24 relative">
                    {/* Connecting Line (Desktop) */}
                    <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-yellow-400/20 to-transparent -translate-y-1/2 z-0"></div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative z-10">
                        {steps.map((step, index) => (
                            <motion.div 
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.2 }}
                                className="relative group"
                            >
                                {/* Step Card */}
                                <div className="bg-white/5 backdrop-blur-md hover:bg-white/10  rounded-[2rem] p-8 border border-white/5 hover:border-yellow-400/30 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-yellow-400/10 h-full flex flex-col items-center text-center group-hover:bg-gray-900/60">
                                    
                                    {/* Number Badge */}
                                    <div className="mb-8 relative">
                                        <div className={`w-20 h-20 rounded-2xl ${step.bgColor} flex items-center justify-center shadow-lg transform rotate-3 group-hover:rotate-6 transition-transform duration-500`}>
                                            <span className="text-white text-2xl font-bold">
                                                {step.number}
                                            </span>
                                        </div>
                                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md">
                                            <div className="text-yellow-500">
                                                {step.icon}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Title */}
                                    <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-yellow-400 transition-colors duration-300">
                                        {step.title}
                                    </h3>

                                    {/* Description */}
                                    <p className="text-gray-400 text-base leading-relaxed">
                                        {step.description}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* CTA Section */}
                <motion.div 
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                    className="relative w-full"
                >
                    {/* Gradient Background */}
                    <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/10 via-yellow-400/5 to-blue-500/10 border border-yellow-400/30 rounded-[2.5rem] blur-3xl"></div>
                    
                    <div className="relative bg-white/5 backdrop-blur-xl rounded-[2.5rem] p-12 md:p-16 border border-white/10 text-center overflow-hidden">
                        
                        
                        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">
                            Listo para vivir la experiencia <span className="text-yellow-400">TVNIMO</span>?
                        </h2>
                        <p className="text-gray-300 text-lg mb-10 max-w-2xl mx-auto">
                            Únase a nuestra comunidad y acceda a lo mejor del entretenimiento en pocos minutos.
                        </p>

                        <button className="bg-yellow-400 hover:bg-yellow-300 text-black font-bold px-4 py-4 md:px-10 rounded-full text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-yellow-400/20 flex items-center gap-2 mx-auto">
                            <span>Comenzar ahora</span>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M8.59 16.59L13.17 12L8.59 7.41L10 6l6 6l-6 6z"/>
                            </svg>
                        </button>
                    </div>
                </motion.div>
            </div>
        </main>
    )
}

